import { api_configuration } from "../../common";
import api_client_state = api_configuration.types.client_state.alan_api;
import { subscribeToCollectionEntry } from "./Query";
import createClientIdPathFromNode from "../navigation/createClientIdPathFromNode";
import { registerQueryEntry } from "../state/registerClientState";
import DestructorTree from "../DestructorTree";

//TODO use guids?
let sel_id = 0;
function generateSelectionId(): string {
	sel_id += 1;
	return sel_id.toString();
}

export function selectEntry(non_selected_entry: api_client_state.Cno__is_selected__entries): void {
	const has_selected_entries = non_selected_entry.parent.parent.parent.properties.has_selected_entries.switch({
		no: () => {
			non_selected_entry.parent.parent.parent.properties.has_selected_entries.set("yes", {
				"selected entries": {},
				"number of selected entries": 0,
				"number of editable selected entries": 0,
			});
			return non_selected_entry.parent.parent.parent.properties.has_selected_entries.cast("yes");
		},
		yes: ($) => $,
	});
	const selection_id = generateSelectionId();

	const selected_entry = has_selected_entries.properties.selected_entries.create(selection_id, {
		"entry status": {
			initialized: non_selected_entry.parent.properties.entry_status.properties.initialized.switch<
				api_client_state.Tquery_entry_status["initialized"]
			>({
				unknown: "unknown",
				yes: ($) => [
					"yes",
					{
						"referenced node": createClientIdPathFromNode($.properties.referenced_node.output.result_node()),
					},
				],
				no: ($) => [
					"no",
					{
						"referenced node": mapClientIdPath($.properties.referenced_node),
					},
				],
			}),
		},
		"is editable": non_selected_entry.parent.properties.is_editable.switch({
			no: ["no", {}],
			yes: ["yes", {}],
		}),
	});
	const destructor = new DestructorTree();
	selected_entry.onDestroy(() => destructor.destroy());
	registerQueryEntry(selected_entry.properties.entry_status, destructor);
	subscribeToCollectionEntry(selected_entry.properties.entry_status);
	non_selected_entry.parent.properties.is_selected.set("yes", {
		"selected entry": selection_id,
	});
	updateEntriesSelection(non_selected_entry.parent.parent.parent);
}

export function deselectEntry(selected_entry: api_client_state.Cselected_entries): void {
	const selected_entries = selected_entry.parent;
	selected_entry.parent.parent.properties.has_result.switch({
		no: undefined,
		yes: (has_result) => {
			has_result.properties.entries.forEach((q_entry) => {
				q_entry.properties.is_selected.switch({
					no: undefined,
					yes: ($) => {
						if ($.properties.selected_entry.ref === selected_entry) {
							q_entry.properties.is_selected.set("no", {});
						}
					},
				});
			});
		},
	});
	selected_entries.properties.selected_entries.delete(selected_entry.key);
	updateEntriesSelection(selected_entry.parent.parent);
}

export function updateEntriesSelection(query: api_client_state.Cquery__client_state): void {
	query.properties.has_selected_entries.switch({
		no: undefined,
		yes: ($) => {
			if ($.properties.selected_entries.size <= 0) {
				query.properties.has_selected_entries.set("no", {});
			} else {
				$.set_number_of_selected_entries($.properties.selected_entries.size);
				$.set_number_of_editable_selected_entries(
					$.properties.selected_entries
						.toArray()
						.reduce((t, $) => t + $[1].properties.is_editable.switch({ no: 0, yes: 1 }), 0)
				);
			}
		},
	});

	query.properties.has_result.switch({
		no: undefined,
		yes: ($) => {
			let has_selected_entries = false;
			let has_unselected_entries = false;
			$.properties.entries.forEach((entry) => {
				entry.properties.is_selected.switch({
					no: () => {
						has_unselected_entries = true;
					},
					yes: () => {
						has_selected_entries = true;
					},
				});
			});
			if (has_selected_entries) {
				if (has_unselected_entries) {
					$.properties.selected_entries.set("some", {});
				} else {
					$.properties.selected_entries.set("all", {});
				}
			} else {
				$.properties.selected_entries.set("none", {});
			}
		},
	});
}

function mapClientIdPath(id_path: api_client_state.Cid_path): api_client_state.Tid_path {
	return {
		"has steps": id_path.properties.has_steps.switch<api_client_state.Tid_path["has steps"]>({
			no: "no",
			yes: ($) => [
				"yes",
				{
					type: $.properties.type.switch<api_client_state.Tyes__has_steps__id_path["type"]>({
						"collection entry": ($) => [
							"collection entry",
							{
								collection: $.properties.collection.entry,
								id: $.properties.id,
							},
						],
						group: ($) => [
							"group",
							{
								group: $.properties.group.entry,
							},
						],
						state: ($) => [
							"state",
							{
								"state group": $.properties.state_group.entry,
								state: $.properties.state.entry,
							},
						],
					}),
					tail: mapClientIdPath($.properties.tail),
				},
			],
		}),
	};
}
